module.exports = __webpack_public_path__ + "static/media/crew-steve.39061854.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/img/crew-steve.png
// module id = 1002
// module chunks = 0